<script>
   /****************************************************************/
   /* PlotPVScalars                                                */
   /* --------------------                                         */
   /* shows heatmap with PCVPLS scalars                            */
   /****************************************************************/

   import { Heatmap, ColormapLegend, Axes, XAxis, YAxis, Box } from 'svelte-plots-basic/2d';
   import { MARGINS, PNG_WIDTH, PNG_HEIGHT, PNG_RES } from './Defaults.js';
   import { csvRow, downloadCSV } from '../utils.js';


   let {
      params,                        // JSON with main plot parameters
      callbacks,                     // JSON with all callback methods
      props,                         // JSON with main properties (model, results, dataset)
      selected,                      // ID of selected object
   } = $props();

   // get model object from properties
   let scalars = $derived(props ? props.scalars : null);

   // the heatmap draws the first row at the top: the rows are reversed so that segment k
   // is centred at y = k
   const heatValues = $derived(scalars ?
      scalars.subset(Array.from({length: scalars.nrows}, (v, i) => scalars.nrows - i), null) : null);

   const breaks = [-99999, -2, -1, 0, 0.2, 0.5, 0.8, 1.2, 1.5, 1.8, 2.0, 2.5, 3.0, 99999];
   const colmap = [
      '#6200DF', // < -2
      '#6923FF', // -2.00 to -1.00
      '#648FFF', // -1.00 to  0.00
      '#8CCDFD', //  0.00 to  0.20
      '#D2ECFF', //  0.20 to  0.50
      '#E8F5FF', //  0.50 to  0.80
      '#fefeff', //  0.80 to  1.20
      '#FFF5E5', //  1.20 to  1.50
      '#FFE5BE', //  1.50 to  1.80
      '#FFCE85', //  1.80 to  2.00
      '#FFA34E', //  2.00 to  2.50
      '#FF8024', //  2.50 to  3.00
      '#CF5903'  //  > 3.0
   ];

   const labels = breaks.map(v => v.toFixed(1));
   labels[0] = '&minus;&infin;';
   labels[labels.length - 1] = '&infin;';

   const dY = $derived(scalars ? scalars.nrows / 8 : 1);
   const limX = $derived(scalars ? [0.45, scalars.ncols + 0.6] : [0, 1]);
   const limY = $derived(scalars ? [0.45, scalars.nrows + Math.max(0.9, dY)] : [0, 1]);

   const title = 'PV-scalars';
   const yLabel = 'Segments, k';
   const xLabel = 'Number of LVs, A';

   // name of the image and CSV files
   const fileName = 'plot-pvscalars';

   // method for creating CSV version of the plot data
   function downloadCSVCallback() {
      const { sep, dec } = Object.values(props.data)[0];
      const comps = Array.from({length: scalars.ncols}, (v, c) => c + 1);
      let out = csvRow([yLabel, ...comps], sep, dec);
      for (let r = 0; r < scalars.nrows; r++) {
         const row = comps.map((v, c) => scalars.getcolref(c + 1)[r]);
         out += csvRow([r + 1, ...row], sep, dec);
      }
      downloadCSV(out, fileName);
   }
</script>

{#if scalars }
<!-- the library Axes, not ./Axes.svelte: the heatmap needs whole ticks on both axes and no grid;
     the export settings the wrapper passes are passed here -->
<Axes {limX} {limY} {title} {fileName} downloadLinks="hover"
   plotActions={[{text: '↓ csv', callback: downloadCSVCallback}]}
   margins={MARGINS} pngWidth={PNG_WIDTH} pngHeight={PNG_HEIGHT} pngRes={PNG_RES}>
   <Heatmap values={heatValues} {breaks} {colmap}/>
   <ColormapLegend {breaks} {colmap} {labels}/>
   <XAxis label={xLabel} whole={true} />
   <YAxis label={yLabel} whole={true} />
   <Box />
</Axes>
{/if}
